<template>
    <div>
        <div class="px-5 mb-3 subtitle-2">Ergebnisdienst Administrator</div>
        <v-expansion-panels class="pb-5 px-5">
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <div class>
                        <v-icon class="mr-2" color="primary">mdi-account</v-icon>
                        Freundschaftsliga anlegen
                    </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="grey lighten-5 pt-5">
                    <ul class="body-2">
                        <li>Freundschaftsligen dürfen nur im Bereich 'nationale Ligen' angelegt werden</li>
                        <li>Beim Anlegen der Liga die Punkte 'Sonstige' und 'keine Tabelle berechnen' auswählen</li>
                        <li>Spiele finden immer in den Runden '1 H' oder '1 F' statt.</li>
                        <li>Vereine, die nicht in österreichischen Ligen gemeldet sind, müssen als
                            'Dummy-Verein' angelegt werden (siehe Punkt
                            'Dummy Verein für Freundschaftsliga anlegen')</li>
                    </ul>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <div class>
                        <v-icon class="mr-2" color="primary">mdi-account-group</v-icon>
                        Dummy Verein für Freundschaftsliga anlegen
                    </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="grey lighten-5 pt-5">
                    <ul class="body-2">
                        <li>In der nationalen Liga findet sich unterhalb des Sportjahres ein zweites Symbol
                            (rechts vom '+' für das Anlegen einer neuen Liga)</li>
                        <li>Durch Anklicken gelangt man in den Bereich zum Anlegen von Vereinen für Testspiele</li>
                        <li>Die Dummy-Vereinsnummern werden automatisch vergeben, es muss nur der Vereinsname
                            eingegeben werden.</li>
                        <li>Nach dem Anlegen des Vereins muss der Verein auch noch als
                            Mannschaft für die Saison angelegt werden.</li>
                    </ul>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
    export default {
        name: "help-admin-ergebnisdienst"
    }
</script>

<style scoped>

</style>